/* This example requires Tailwind CSS v2.0+ */
import React, { useEffect, Suspense, useState } from 'react';

import appmaker from '@appmaker/core/index';
import ProjectBuildRoutes from './ProjectBuildRoutes';
import { BeakerIcon, CubeIcon, DeviceMobileIcon } from '@heroicons/react/solid';
import useProject from '@appmaker/core/hooks/useProject';
import useProjectData from '@appmaker/core/hooks/useProjectData';
import {
	setProject,
	setProjectId,
	usePlugins,
} from '@appmaker/core/store/project';
import { Helmet } from 'react-helmet';
import SidebarNavigation from 'components/SidebarNavigation';
import DashboardLoading from 'components/skeltonLoading/Dashboard';
import DashboardLayout from 'components/layout/dashboard';
import {
	setSideBarStatus,
	setSmallSidebar,
} from '@appmaker/core/store/settings';
import isEmpty from 'lodash/isEmpty';
import { setUser } from '@appmaker/core/store/user';
const getAllNavs = () => {
	const menuItems = [
		{ name: 'App Builds', routeName: '/app-builds', icon: BeakerIcon },
		{ name: 'Extensions', routeName: '/extension', icon: CubeIcon },
		{ name: 'Themes', routeName: '/themes', icon: DeviceMobileIcon },
	];
	return menuItems;
};
const SideNav = () => {
	const navigation = getAllNavs();
	return <SidebarNavigation navigation={navigation} />;
};
const RouterHelper = ({ Component, setFullLayout, AdditionalComponent }) => {
	useEffect(() => {
		// if (Component.fullLayout !== fullLayout)
		if (Component.fullLayout) setFullLayout(true);
		else setFullLayout(false);
	}, [Component.fullLayout, setFullLayout]);
	useEffect(() => {
		// if (Component.fullLayout !== fullLayout)
		if (Component.hideSideBar === true) setSideBarStatus(false);
		else setSideBarStatus(true);
	}, [Component.hideSideBar]);
	useEffect(() => {
		// if (Component.fullLayout !== fullLayout)
		if (Component.smallSidebar === true) setSmallSidebar(true);
		else setSmallSidebar(false);
	}, [Component.smallSidebar]);

	return (
		<>
			{AdditionalComponent ? AdditionalComponent : <Component />}

		</>
	);
};
export default function Dashboard() {
	const [fullLayout, setFullLayout] = useState(false);
	const [pluginsLoaded, setPLuginsLoaded] = useState(false);
	const { projectId } = useProject();
	const { projectData, loading } = useProjectData({ projectId, buildOnly: true });
	const plugins = usePlugins();
	const AdditionalComponent = appmaker.applyFilters(
		'additional-override-component-full-screen',
		null
	);
	useEffect(() => {
		if (
			(!isEmpty(projectData) && projectData?.status !== false) &&
			plugins &&
			!pluginsLoaded
		) {
			let allPlugins = plugins;
			if (projectData?.feature?.dashboard_sidebar_plugins) {
				allPlugins = allPlugins.concat(
					projectData?.feature?.dashboard_sidebar_plugins
				);
			}
			let uniquePlugins = [];
			allPlugins?.forEach((plug) => {
				const unq = uniquePlugins?.find((item) => item.id === plug.id);
				if (!unq) {
					uniquePlugins?.push(plug);
				}
			});
			appmaker.activatePlugins(uniquePlugins);
			setPLuginsLoaded(true);
		} else if ((isEmpty(projectData) || projectData?.status === false) && !loading) {
			setUser({
				logged_in: false
			})
		}
	}, [plugins]);

	useEffect(() => {
		if (projectData) setProject(projectData);
	}, [projectData]);
	useEffect(() => {
		setProjectId(projectId);
	}, [projectId]);
	return (loading || !pluginsLoaded) ? (
		<DashboardLoading />
	) : (
		<>
			<DashboardLayout
				showSidebarTop={false}
				appIcon={projectData.icon}
				appName={projectData.name}
				templateName={projectData.template}
				sideNav={<SideNav />}
				fullLayout={fullLayout}
			>
				<Helmet>
					<title>{projectData.name} - Appmaker.xyz</title>
				</Helmet>
				<Suspense fallback={<DashboardLoading />}>
					<ProjectBuildRoutes renderBuild={(Component) => (
						<RouterHelper Component={Component} setFullLayout={setFullLayout} AdditionalComponent={AdditionalComponent} />
					)} />
				</Suspense>
			</DashboardLayout>
		</>
	);
}
